import domainDictionary from './domainDictionary';

function safeGtag(event, params = {}) {
  if (process.env.NODE_ENV !== 'production') {
    console.debug('[analytics]', event, params)
  }
  if (typeof window?.gtag === 'function') {
    if (params) {
      window.gtag('event', event, params)
    } else {
      window.gtag('event', event)
    }
  }
}

export default {
  linkSubmit(link) {
    safeGtag('link_submit', {
      host: getHost(link)
    })
  },

  showResults(link) {
    safeGtag('request_success', {
      host: getHost(link)
    })
  },

  showError(link, label) {
    safeGtag('request_failed', {
      host: getHost(link),
      label: label
    })
  },

  // eventLabel — источник скачивания ('playlist' у карточки плейлиста);
  // у одиночного видео не задаётся, и событие остаётся прежним
  downloadClick(link, format, eventLabel) {
    safeGtag('download_click', {
      host: getHost(link),
      format: format || 'unknown',
      ...(eventLabel ? {event_label: eventLabel} : {})
    })
  },

  playlistGetLinkClick(link) {
    safeGtag('playlist_get_link_click', {
      host: getHost(link)
    })
  },

  converterRequest() {
    safeGtag('converter_request_send')
  },

  converterRequestSuccess() {
    safeGtag('converter_request_success')
  },

  converterRequestFailed() {
    safeGtag('converter_request_failed')
  },

  converterClick(format) {
    safeGtag(
      format ? 'converter_download' : 'converter_download_all',
      {format: format || 'all'}
    )
  },
}

export function getHost(link) {
  try {
    const aTmp = document.createElement('a')
    aTmp.href = link
    return domainDictionary(aTmp.hostname)
  } catch {
    return 'unknown'
  }
}
